import { FC, Fragment, memo } from "react";
import { FormikHandlers } from "formik";
import {
  AutocompleteFilterBody,
  AutocompleteFilterBodyProps,
} from "../AutocompleteFilterBody";
import {
  FilterItem,
  Operator,
  useGetUsersMeRdsSnapshotTypesQuery,
} from "../../../../../../../../services/cloudchipr.api";
import { FilterItemOperatorType } from "../../../FilterItemOperatorType";

interface SnapshotTypeFilterProps extends AutocompleteFilterBodyProps {
  filter: FilterItem;
  operators?: Operator[];
  onChange: FormikHandlers["handleChange"];
}

export const SnapshotTypeFilter: FC<SnapshotTypeFilterProps> = memo(
  ({ operators, filter, onChange, ...props }) => {
    const { data, isLoading } = useGetUsersMeRdsSnapshotTypesQuery();

    return (
      <Fragment>
        <FilterItemOperatorType
          onChange={onChange}
          options={operators}
          value={filter.operator || "in"}
        />

        <AutocompleteFilterBody
          {...props}
          options={data ?? []}
          isLoading={isLoading}
          label="Snapshot Type"
          selectedValue={Array.isArray(filter?.value) ? filter.value : []}
        />
      </Fragment>
    );
  },
);
